<ng-container *ngIf="mappings != null">
  <div class="row">
    <div class="col-12 col-lg-6">
      <label>GL Account</label>
      <input
        type="text"
        name="glAccount"
        class="form-control"
        [(ngModel)]="glAccount"
        *ngIf="config.ExportFileType != GeneralLedgerExportTypes.QBO" />
      <select
        *ngIf="config.ExportFileType == GeneralLedgerExportTypes.QBO"
        class="form-control"
        name="glAccount"
        [(ngModel)]="glAccount">
        <option [ngValue]="null" disabled></option>
        <option
          *ngFor="let qboAccount of qboAccounts | async"
          [ngValue]="qboAccount.FullyQualifiedName">
          {{ qboAccount.FullyQualifiedName }}
        </option>
      </select>
    </div>
    <div class="col-12 col-lg-6">
      <label>Offset</label>
      <input
        type="text"
        name="offset"
        class="form-control"
        [(ngModel)]="offset"
        *ngIf="config.ExportFileType != GeneralLedgerExportTypes.QBO" />
      <select
        *ngIf="config.ExportFileType == GeneralLedgerExportTypes.QBO"
        class="form-control"
        name="offset"
        [(ngModel)]="offset">
        <option [ngValue]="null" disabled></option>
        <option
          *ngFor="let qboAccount of qboAccounts | async"
          [ngValue]="qboAccount.FullyQualifiedName">
          {{ qboAccount.FullyQualifiedName }}
        </option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h5>Check Export Mappings</h5>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="row">
        <div class="col-4">
          <span class="fw-bold">Include</span>
        </div>
        <div class="col-4">
          <span class="fw-bold">Name</span>
        </div>
        <div class="col-4">
          <span class="fw-bold">Number</span>
        </div>
      </div>
      <div class="row" *ngFor="let mapping of mappings.Rows">
        <div class="col-4 d-flex flex-column justify-content-center">
          <lib-checkbox
            [size]="CheckboxSizes.Small"
            [label]="mapping.TypeName"
            [ngModel]="!mapping.NotExported"
            (ngModelChange)="toggleNotExported($event, mapping)"></lib-checkbox>
        </div>
        <ng-container *ngIf="!mapping.NotExported">
          <div class="col-4">
            <input
              class="form-control mb-0"
              [name]="'mapping.TypeName' + '_name'"
              [(ngModel)]="mapping.CheckName" />
          </div>
          <div class="col-4">
            <input
              class="form-control mb-0"
              [name]="'mapping.TypeName' + '_number'"
              [(ngModel)]="mapping.CheckNumber" />
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="row mt-3" *ngIf="(balance | async) != null">
    <div class="col-12">
      <span class="fw-bold">Balance: </span>
      <span *ngIf="(balance | async) >= 0" class="text-cp-green">{{
        balance | async | currency: '' : ''
      }}</span>
      <span *ngIf="(balance | async) < 0" class="text-danger"
        >({{ balance | async | absoluteValue | currency: '' : '' }})</span
      >
    </div>
  </div>
  <div class="row mb-5">
    <div class="col-12 text-end">
      <button class="btn btn-secondary me-3" (click)="cancel()">Cancel</button>
      <button class="btn btn-primary" (click)="submit()">Save Setup</button>
    </div>
  </div>
</ng-container>
